export const dollarStringToNumber = (dollarString: string): Maybe<number> => {
    const withoutDollarSignsAndCommas = dollarString.replace(/\$|,/g, '');
    const matchesNonDigitsOrNonDecimalPoint = /[^0-9.]+/.test(
        withoutDollarSignsAndCommas,
    );

    if (matchesNonDigitsOrNonDecimalPoint) {
        return null;
    }

    const asNumber = parseFloat(withoutDollarSignsAndCommas);

    if (Number.isNaN(asNumber)) {
        return null;
    }

    return asNumber;
};
